__turbopack_context__.v({
  "pointlistpoint": "W6FXeW_pointlistpoint",
  "pointlistpoint__heading": "W6FXeW_pointlistpoint__heading",
  "pointlistpoint__number": "W6FXeW_pointlistpoint__number",
  "pointlistpoint__paragraph": "W6FXeW_pointlistpoint__paragraph",
  "top": "W6FXeW_top",
});
